<template>
    <main class="freedom_bank phone screen details-screen">
        <section class="hero-card">
            <div class="hero-text">
                <h3 class="hero-label">Табыс жиналатын инвестиция</h3>
                <p>жылына 7,28 % - ға дейін USD бойынша</p>
                <p>жылдық 3,15 % дейін EUR</p>
            </div>
            <div class="hero-coins">
                <span>$</span>
                <span>€</span>
            </div>
        </section>

        <section class="action-grid">
            <article class="action-card">
                <span class="action-icon action-icon-pay"></span>
                <h3>Толтыру</h3>
                <p>ApplePay, картасынан немесе есептік жазбасынан...</p>
            </article>
            <article class="action-card">
                <span class="action-icon action-icon-send"></span>
                <h3>Жіберу</h3>
                <p>Картаға, есептік жазбаға, қызметтерге ақы төлеу ...</p>
            </article>
            <article class="action-card">
                <span class="action-icon action-icon-settings"></span>
                <h3>Теңшеулер</h3>
                <p>Хабарландырулар, шектеулер, қауіпсіздік...</p>
            </article>
            <article class="action-card">
                <span class="action-icon action-icon-info"></span>
                <h3>Ақпарат</h3>
                <p>Мәліметтер, тарифтер, мәлімдемелері...</p>
            </article>
        </section>

        <section class="transactions">
            <h2>Соңғы транзакциялар</h2>

            <article class="transaction-row" v-for="item in $store.state.data.transactions.transactions" :class="{'positive': item.amount[0] == '+'}">
                <div class="transaction-main">
                    <span class="transaction-icon transport">
                        <img :src="`${$config.ApplicationPublicURL}/img/freedom/transactions/${item.image}`" style="width: 14px;height: 14px;"/>
                    </span>
                    <div>
                        <h3>{{ item.name }}</h3>
                        <p>{{ item.description }}</p>
                    </div>
                </div>
                <div class="transaction-side">
                    <strong>{{ item.amount }}</strong>
                    <span>{{ item.date }}</span>
                </div>
            </article>

        </section>

        <div class="wide-button">Карта бойынша барлық транзакциялар</div>
        <div class="bottom-cta" @click="toHome">Карталар мен өнімдер</div>
    </main>

</template>

<script>
    export default {
    	head: {
    		meta: [
                {
                    name: 'application-name', 
                    content: 'Freedom'
                },
                {
                    name: 'apple-mobile-web-app-title', 
                    content: 'Freedom'
                },
                {
                    name: 'author', 
                    content: 'Freedom'
                }
            ],
            link: [
            	{
                    rel: 'apple-touch-icon',
                    href: require('../../assets/freedom/favicon/180x180.png')
                },
                {
                    rel: 'shortcut icon',
                    href: require('../../assets/freedom/favicon/32x32.png'),
                    sizes: '32x32',
                    type: 'image/png'
                },
            ]
    	},
        data() {
            return {}
        },
        methods: {
            toHome() {
            	this.$router.replace({
                    name: 'FreedomHome',
                    params: { 0: `/${this.$route.path}` },
                    replace: true,
                })
            }
        }
    }
</script>
